import { OfficePrimitiveParameterValue } from '~/scenes/Automation/Flows/Actions/Base/types.flow';

import { PARAMETER_VALUE_TYPE } from '../constants';

export default (value?: string | null): OfficePrimitiveParameterValue => ({
  type: PARAMETER_VALUE_TYPE.OFFICE_PRIMITIVE,
  value,
});
